import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPole = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.0909 21.0909V12.3764L5.25994 6.54545H2.90909C2.40701 6.54545 2 6.13844 2 5.63636C2 5.13429 2.40701 4.72727 2.90909 4.72727V3.81818C2.90909 3.3161 3.3161 2.90909 3.81818 2.90909C4.32026 2.90909 4.72727 3.3161 4.72727 3.81818V4.72727H6.54545V3.81818C6.54545 3.3161 6.95247 2.90909 7.45455 2.90909C7.95662 2.90909 8.36364 3.3161 8.36364 3.81818V4.72727H11.0909V2.90909C11.0909 2.40701 11.4979 2 12 2C12.5021 2 12.9091 2.40701 12.9091 2.90909V4.72727H15.6364V3.81818C15.6364 3.3161 16.0434 2.90909 16.5455 2.90909C17.0475 2.90909 17.4545 3.3161 17.4545 3.81818V4.72727H19.2727V3.81818C19.2727 3.3161 19.6797 2.90909 20.1818 2.90909C20.6839 2.90909 21.0909 3.3161 21.0909 3.81818V4.72727C21.593 4.72727 22 5.13429 22 5.63636C22 6.13844 21.593 6.54545 21.0909 6.54545H18.7401L12.9091 12.3764V21.0909C12.9091 21.593 12.5021 22 12 22C11.4979 22 11.0909 21.593 11.0909 21.0909ZM11.0909 9.8054V6.54545H7.83097L11.0909 9.8054ZM12.9091 9.8054L16.169 6.54545H12.9091V9.8054Z",
		fill: "currentColor"
	})
});
export default SvgPole;
